import { Component, OnInit } from '@angular/core';
import { ScreenCreatorTransactionService } from "src/app/shared/services/screen-creator-transaction.service";
import { MatDialog } from '@angular/material/dialog';
import { ColumnTypesComponent } from 'src/app/user/column-types/column-types.component';
import { UntypedFormGroup, UntypedFormControl, Validators } from "@angular/forms";
import { validationmethod } from "src/app/shared/common/validationmethod";
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { FormFieldsTrimAndClean } from "src/app/shared/common/trim-clean-Data";
import { MatSnackBar } from '@angular/material/snack-bar';
import { constants } from "src/app/shared/common/contants"
import { publishButton } from "src/app/shared/common/publishButton";
import { TransactionDataPopupComponent } from 'src/app/user/transaction-data-popup/transaction-data-popup.component';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { BehaviorSubject, Observable, of as observableOf } from 'rxjs';
import { ScreensService } from 'src/app/shared/services/screens.service';
import { TransactionScreenCreatorDeleteComponent } from 'src/app/user/transaction-screen-creator-delete/transaction-screen-creator-delete.component';
import { ImageViewInPopupComponent } from '../image-view-in-popup/image-view-in-popup.component';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonTs } from 'src/app/shared/common/CommonTs';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';

export interface NumberOfColumnsInRowType {
  name: string,
  value: number
}

export class FileNode {
  children: FileNode[];
  text: string;
  urlPath: String;
  screenType: String;
  screenName: String;
}

@Component({
    selector: 'app-screen-creator-transaction',
    templateUrl: './screen-creator-transaction.component.html',
    styleUrls: ['./screen-creator-transaction.component.scss'],
    standalone: false
})
export class ScreenCreatorTransactionComponent implements OnInit {

  retrieveFieldsObject: any = [];

  allFieldsOfMasterTable: any = [];

  totalObjectOfMasterTable: any = [];

  displayNamesOfMasterTable: any = [];

  object = Object;

  allFieldsOfTransactionTable: any = [];

  totalObjectOfTransactionTable: any = [];

  displayNamesOfTransactionTable: any = [];

  screenCreatorFields = { screenName: "", displayName: "", numberOfColumnsInRow: "", screenImageName: "", screenImage: "", multiTenant: true };

  formValid: UntypedFormGroup;

  validation_messages;

  masterTableName = "";

  masterTableID = "";

  transactionTableName = "";

  transactionTableID = "";

  numberOfColumnsInRowData: NumberOfColumnsInRowType[] = [
    { name: "1", value: 1 },
    { name: "2", value: 2 },
    { name: "3", value: 3 },
    { name: "4", value: 4 }
  ];

  menus: any;

  nestedTreeControl: NestedTreeControl<FileNode>;

  nestedDataSource: MatTreeNestedDataSource<FileNode>;

  dataChange: BehaviorSubject<FileNode[]> = new BehaviorSubject<FileNode[]>([]);

  screenNameData: any

  components: any;

  columnDefs;

  rowClassRules;

  rowSelection;

  paginationPageSize;

  paginationNumberFormatter;

  gridApi;

  lastpage;

  currentpage;

  nextpage;

  nextpageplusone;

  totalpages;

  defaultColDef;

  private gridColumnApi;

  pagesize;

  retrieveMetaObject: any = [];

  showMenuOrder = false;

  value;

  screenImage = "";

  screenImageShow: any = false;

  selectedScreenCreator = "MasterScreenCreator";
  
  backgroundColorButton: any;
  backgroundColorScreen;

  constructor(private commonTs:CommonTs, private service: ScreenCreatorTransactionService, private localStorageSettings: LocalStorageSettingsService, private dialog: MatDialog, private validation: validationmethod, private errormessages: ErrorMessages, private trimCleanData: FormFieldsTrimAndClean, private spinner: NgxUiLoaderService, private screenService: ScreensService, private snackBar: MatSnackBar, private constant: constants, private sanitizer: DomSanitizer) {

    //messages for validations
    this.validation_messages = this.errormessages.screenCreatorTransactionMessages;

    //cell rendering in ag-grid
    this.components = { buttonRenderer: publishButton };

  }

  async ngOnInit() {

    this.formValidations();

    await this.retrieveFields();

    // if the record has status==no , row color will change
    this.rowClassRules = {
      grey: function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      }
    };

    // below object is resizable, sorting and filter for ag-grid

    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.rowSelection = "single";

    this.paginationPageSize = 10;
    
    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
    
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD")

    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };

    this.screenService.retrieveWebDropDown().subscribe(menus => {
      this.menus = menus[1];
      console.log(this.menus)
      this.dataChange.next(this.menus);
      console.log(this.menus)
    });
    this.nestedTreeControl = new NestedTreeControl<FileNode>(this._getChildren);
    this.nestedDataSource = new MatTreeNestedDataSource();

    this.dataChange.subscribe(data => this.nestedDataSource.data = data);

    this.showMenuOrder = true;

  }

  private _getChildren = (node: FileNode) => { return observableOf(node.children); };
  hasNestedChild = (_: number, nodeData: FileNode) => { return !(nodeData.urlPath); };

  screenNameSelect(screenName) {
    console.log(screenName);
    if (screenName == "Parent itself") {
      this.screenNameData = "Parent itself";

    } else {
      this.screenNameData = screenName;

    }
  }

  removeFieldFromMasterTable(totalObjectTemp, temporaryIndex) {

    this.spinner.start();

    console.log(temporaryIndex);

    console.log(totalObjectTemp);

    //Getting the value of pairedValue of selected fieldName
    let pairedValue = this.allFieldsOfMasterTable[temporaryIndex][0].pairedValue;

    console.log(pairedValue);

    //If pairedValue is zero, it means it does not related fields
    if (pairedValue == 0) {

      //Removing the array at temporaryIndex
      this.allFieldsOfMasterTable.splice(temporaryIndex, 1);

      console.log(this.allFieldsOfMasterTable);

      //Removing the json at temporaryIndex
      this.totalObjectOfMasterTable.splice(temporaryIndex, 1);

      console.log(this.totalObjectOfMasterTable);

      //Removing the json at temporaryIndex
      this.displayNamesOfMasterTable.splice(temporaryIndex, 1);

      console.log(this.displayNamesOfMasterTable);

    }

    //Initializing fieldNameIndexs with zero
    let numberOfRelatedFields = 0;

    //Initalizing fieldNameValues with empty array
    let fieldNameValues = [];

    //If pairedValue greater then zero, it means it has related fields
    if (pairedValue > 0) {

      //Iterating allFieldsOfMasterTable
      for (let i = 0; i < this.allFieldsOfMasterTable.length; i++) {

        //if pairedValue are same
        if (this.allFieldsOfMasterTable[i][0].pairedValue == pairedValue) {

          //Increment numberOfRelatedFields
          numberOfRelatedFields++;

          //Storing fieldName value
          fieldNameValues.push(this.allFieldsOfMasterTable[i][0].keyValue);

        }

      }

      console.log(numberOfRelatedFields);

      console.log(fieldNameValues);

      //Intializing messageTemp with empty string
      let messageTemp = "";

      //Iterating fieldNameValues
      for (let i = 0; i < fieldNameValues.length; i++) {

        if (i == fieldNameValues.length - 1) {

          messageTemp = messageTemp + fieldNameValues[i];

        }

        else {

          messageTemp = messageTemp + fieldNameValues[i] + ", ";

        }

      }

      console.log(messageTemp);

      let messageTemporary = messageTemp + " Field Names are related fields. If you remove " + totalObjectTemp.fieldName + " the related fields also remove automatically. Are you sure you want to remove " + totalObjectTemp.fieldName;

      if (confirm(messageTemporary) == true) {

        //Iterating fieldNameIndexs
        for (let i = 0; i < numberOfRelatedFields; i++) {

          //Iterating allFieldsOfMasterTable
          for (let j = 0; j < this.allFieldsOfMasterTable.length; j++) {

            //if pairedValue are same
            if (this.allFieldsOfMasterTable[j][0].pairedValue == pairedValue) {

              //Removing the array at fieldNameIndexs of i
              this.allFieldsOfMasterTable.splice(j, 1);

              console.log(this.allFieldsOfMasterTable);

              //Removing the json at fieldNameIndexs of i
              this.totalObjectOfMasterTable.splice(j, 1);

              console.log(this.totalObjectOfMasterTable);

              //Removing the json at fieldNameIndexs of i
              this.displayNamesOfMasterTable.splice(j, 1);

              console.log(this.displayNamesOfMasterTable);

            }

          }

        }

      }

    }

    this.spinner.stop();

  }

  removeFieldFromTransactionTable(totalObjectTemp, temporaryIndex) {

    this.spinner.start();

    console.log(temporaryIndex);

    console.log(totalObjectTemp);

    let pairedValue = this.allFieldsOfTransactionTable[temporaryIndex][0].pairedValue;

    console.log(pairedValue);

    if (pairedValue == 0) {

      this.allFieldsOfTransactionTable.splice(temporaryIndex, 1);

      console.log(this.allFieldsOfTransactionTable);

      this.totalObjectOfTransactionTable.splice(temporaryIndex, 1);

      console.log(this.totalObjectOfTransactionTable);

      this.displayNamesOfTransactionTable.splice(temporaryIndex, 1);

      console.log(this.displayNamesOfTransactionTable);

    }

    //Initializing fieldNameIndexs with zero
    let numberOfRelatedFields = 0;

    //Initalizing fieldNameValues with empty array
    let fieldNameValues = [];

    //If pairedValue greater then zero, it means it has related fields
    if (pairedValue > 0) {

      //Iterating allFieldsOfTransactionTable
      for (let i = 0; i < this.allFieldsOfTransactionTable.length; i++) {

        //if pairedValue are same
        if (this.allFieldsOfTransactionTable[i][0].pairedValue == pairedValue) {

          //Increment numberOfRelatedFields
          numberOfRelatedFields++;

          //Storing fieldName value
          fieldNameValues.push(this.allFieldsOfTransactionTable[i][0].keyValue);

        }

      }

      console.log(numberOfRelatedFields);

      console.log(fieldNameValues);

      //Intializing messageTemp with empty string
      let messageTemp = "";

      //Iterating fieldNameValues
      for (let i = 0; i < fieldNameValues.length; i++) {

        if (i == fieldNameValues.length - 1) {

          messageTemp = messageTemp + fieldNameValues[i];

        }

        else {

          messageTemp = messageTemp + fieldNameValues[i] + ", ";

        }

      }

      console.log(messageTemp);

      let messageTemporary = messageTemp + " Field Names are related fields. If you remove " + totalObjectTemp.fieldName + " the related fields also remove automatically. Are you sure you want to remove " + totalObjectTemp.fieldName;

      if (confirm(messageTemporary) == true) {

        //Iterating fieldNameIndexs
        for (let i = 0; i < numberOfRelatedFields; i++) {

          //Iterating allFieldsOfMasterTable
          for (let j = 0; j < this.allFieldsOfTransactionTable.length; j++) {

            //if pairedValue are same
            if (this.allFieldsOfTransactionTable[j][0].pairedValue == pairedValue) {

              //Removing the array at fieldNameIndexs of i
              this.allFieldsOfTransactionTable.splice(j, 1);

              console.log(this.allFieldsOfTransactionTable);

              //Removing the json at fieldNameIndexs of i
              this.totalObjectOfTransactionTable.splice(j, 1);

              console.log(this.totalObjectOfTransactionTable);

              //Removing the json at fieldNameIndexs of i
              this.displayNamesOfTransactionTable.splice(j, 1);

              console.log(this.displayNamesOfTransactionTable);

            }

          }

        }

      }

    }

    this.spinner.stop();

  }

  addFieldsToMasterTable() {

    let width = "80%";

    let dialogRef = this.dialog.open(ColumnTypesComponent, {
      maxWidth: '100vw',
      width: width,
      data: { retrieveFieldsObject: this.retrieveFieldsObject, allFields: this.allFieldsOfMasterTable, totalObject: this.totalObjectOfMasterTable, displayNames: this.displayNamesOfMasterTable },
      disableClose: true
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {

      console.log(result);

      this.allFieldsOfMasterTable = result[0];

      this.totalObjectOfMasterTable = result[1];

      this.displayNamesOfMasterTable = result[2];

    });

  }

  addFieldsToTransactionTable() {

    let width = "80%";

    let dialogRef = this.dialog.open(ColumnTypesComponent, {
      maxWidth: '100vw',
      width: width,
      data: { retrieveFieldsObject: this.retrieveFieldsObject, allFields: this.allFieldsOfTransactionTable, totalObject: this.totalObjectOfMasterTable, displayNames: this.displayNamesOfMasterTable },
      disableClose: true
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {

      console.log(result);

      this.allFieldsOfTransactionTable = result[0];

      this.totalObjectOfTransactionTable = result[1];

      this.displayNamesOfTransactionTable = result[2];

    });

  }

  async retrieveFields() {

    this.retrieveFieldsObject = [];

    this.retrieveFieldsObject = await this.service.retrieveFieldsService();

    console.log(this.retrieveFieldsObject);

  }

  formValidations() {
    // form validations
    this.formValid = new UntypedFormGroup({
      screenName: new UntypedFormControl("", [Validators.required, this.validation.noWhitespaceValidator, Validators.pattern('^[a-z]+$'), Validators.maxLength(64)]),
      displayName: new UntypedFormControl("", [Validators.required, this.validation.noWhitespaceValidator,this.validation.specialCharacterValidator, Validators.maxLength(50)]),
      numberOfColumnsInRow: new UntypedFormControl("", [Validators.required]),
      screenImageName: new UntypedFormControl("", [Validators.required]),
      screenImage: new UntypedFormControl("")
    });

  }

  screenNameIsChanged() {

    if (this.screenCreatorFields.screenName != null) {

      this.masterTableName = this.screenCreatorFields.screenName + "mstr";

      this.masterTableID = this.screenCreatorFields.screenName + "mstrid";

      this.transactionTableName = this.screenCreatorFields.screenName + "trxn";

      this.transactionTableID = this.screenCreatorFields.screenName + "trxnid";

    }

  }

  async create() {

    //Checking the form is valid or not while insert
    if (!this.formValid.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValid);

      this.validation.getvalidationmessage();

    }

    else {

      if (this.screenNameData == "") {

        this.snackBar.open(this.constant.parentLevel, "OK", { duration: 5000 });

      }
      else {



        //Triming the fields
        this.trimCleanData.trimScreenCreatorFields(this.screenCreatorFields);

        //Removing fields which does not have values
        this.trimCleanData.clean(this.screenCreatorFields);

        console.log(this.screenCreatorFields);

        let isExecute = true;

        let transactionScreenCreatorObject = {};

        if (this.totalObjectOfMasterTable.length > 0) {

          let transactionTableTemp = false;

          if (this.selectedScreenCreator == "TransactionScreenCreator") {

            if (this.totalObjectOfTransactionTable.length > 0) {

              transactionTableTemp = true;

            }

          }

          else {

            transactionTableTemp = true;

          }

          if (transactionTableTemp) {

            let screenTypeTemp = "";

            if (this.selectedScreenCreator == "MasterScreenCreator") {

              screenTypeTemp = "Master";

            }

            else {

              screenTypeTemp = "Transaction";

            }

            //for insert and update services iam pushing this primary key and foreign key in the master and child tableDetails.temporary so by using pop iam removing them after inserting.
            let foreignKey = { "fieldName": this.masterTableID, "fieldType": "Integer Number", "dataType": "INT", "maxLength": "11", "mandatory": "true", "showinGrid": true, "agGridColumnName": this.masterTableID }
            let primaryKey = { "fieldName": this.transactionTableID, "fieldType": "Integer Number", "dataType": "INT", "maxLength": "11", "mandatory": "true", "showinGrid": true, "agGridColumnName": this.transactionTableID }
            this.totalObjectOfMasterTable.unshift(foreignKey);
            this.totalObjectOfTransactionTable.unshift(foreignKey);
            this.totalObjectOfTransactionTable.unshift(primaryKey);
            //Creating object for insert operation
            transactionScreenCreatorObject = {
              "masterTableName": this.masterTableName,
              "childTableName": this.transactionTableName,
              "masterScreenName": this.screenCreatorFields.displayName,
              "masterParentLevel": this.screenNameData,
              "masterTableDetails": {
                "tableName": this.masterTableName, "colSpan": this.screenCreatorFields.numberOfColumnsInRow, "tableID": this.masterTableID,
                "tableData": this.totalObjectOfMasterTable, "multiTenant": this.screenCreatorFields.multiTenant
              },
              "childTableDetails": {
                "tableName": this.transactionTableName, "colSpan": this.screenCreatorFields.numberOfColumnsInRow, "tableID": this.transactionTableID, "tableData": this.totalObjectOfTransactionTable, "multiTenant": this.screenCreatorFields.multiTenant
              },
              "screenImage": this.screenCreatorFields.screenImage,
              "typeOfScreenCreator": this.selectedScreenCreator,
              "screenType": screenTypeTemp,
              "multiTenant": this.screenCreatorFields.multiTenant
            }

          }

          else {

            isExecute = false;

            this.snackBar.open(this.constant.transactionTableMessage, "OK", { duration: 5000 });

          }

        }

        else {

          isExecute = false;

          this.snackBar.open(this.constant.masterTableMessage, "OK", { duration: 5000 });

        }

        console.log(transactionScreenCreatorObject);

        //If isExecute is true
        if (isExecute) {

          //Api call to insert data.
          let error = await this.service.insertService(transactionScreenCreatorObject);
          this.totalObjectOfMasterTable.shift();
          this.totalObjectOfTransactionTable.shift();
          this.totalObjectOfTransactionTable.shift();
          console.log(this.totalObjectOfMasterTable)
          console.log(this.totalObjectOfTransactionTable)
          //If insert operation is successfully completed then error will be false
          if (error == false) {

            this.reset();

          }

        }

      }

    }

  }

  //excel export function
  onBtExport() {
    this.gridApi.exportDataAsCsv();
  }

  //pagination code
  onPaginationChanged() {
    if (this.gridApi) {
      this.lastpage = this.gridApi.paginationIsLastPageFound();
      this.currentpage = this.gridApi.paginationGetCurrentPage() + 1;
      this.nextpage = this.gridApi.paginationGetCurrentPage() + 1 + 1;
      this.nextpageplusone =
        this.gridApi.paginationGetCurrentPage() + 1 + 1 + 1;
      this.totalpages = this.gridApi.paginationGetTotalPages();
    }
  }
  //this function is for going to the given page number
  onSearchChange(searchValue: number) {
    this.gridApi.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {

    var value = this.pagesize;

    this.gridApi.setGridOption('paginationPageSize', Number(value));

  }

  // below function is for going to next page
  onBtNext() {

    console.log("next");

    this.gridApi.paginationGoToNextPage();

  }

  // below function for going to previous page
  onBtPrevious() {

    console.log("previous");

    this.gridApi.paginationGoToPreviousPage();

  }

  // below function for going to first page
  onBtFirst() {

    console.log("first");

    this.gridApi.paginationGoToFirstPage();

  }

  // below function for going to last page
  onBtLast() {

    console.log("last");

    this.gridApi.paginationGoToLastPage();

  }
  //pagination code ends

  // below function is to load the ag grid
  async onGridReady(params) {
    console.log(params)
    this.gridApi = params.api;

    this.gridColumnApi = params.columnApi;

    await this.retrieve();

  }

  async retrieve() {

    this.retrieveMetaObject = [];

    let retrieveObject: any = [];

    let agGridObject = [];

    let screenTypeTemp = "";

    if (this.selectedScreenCreator == "MasterScreenCreator") {

      screenTypeTemp = "Master";

    }

    else {

      screenTypeTemp = "Transaction";

    }

    console.log(screenTypeTemp);

    //It returns data which shows in ag grid
    retrieveObject = await this.service.retrieveAgGridService(screenTypeTemp);
    console.log(retrieveObject)
    if (retrieveObject === null || retrieveObject === undefined || retrieveObject === "" || retrieveObject === "null") {
      this.gridApi.setGridOption('rowData', agGridObject);
    } else {
      console.log(retrieveObject);

      let fieldNamesObject: any = [];

      let fieldNamesKeysValues: any = [];

      console.log(retrieveObject[0]);

      fieldNamesKeysValues = JSON.parse(retrieveObject[0]);

      console.log(fieldNamesKeysValues);

      let headerNames = JSON.parse(retrieveObject[1]);

      console.log(headerNames);

      fieldNamesObject = Object.keys(fieldNamesKeysValues);

      console.log(fieldNamesObject);

      console.log(fieldNamesObject.length);

      let fieldNamesObjectTemp = [];

      for (let i = 0; i < fieldNamesObject.length; i++) {

        let j = i + 1;

        fieldNamesObjectTemp.push("keyName" + j);

      }

      console.log(fieldNamesObjectTemp);

      fieldNamesObject = [];

      fieldNamesObject = fieldNamesObjectTemp;

      console.log(fieldNamesObject);

      //Initializing columnDefs with empty array
      this.columnDefs = [];

      //This is first column, it is for publish and unpublish
      this.columnDefs.push({
        headerName: "Publish/UnPublish",
        filter: false,
        cellRenderer: "buttonRenderer",
        cellRendererParams: {
          publishButton: this.publishdata.bind(this),
          unPublishButton: this.unpublishdata.bind(this),
        },
        width: 180
      });

      //Iterating fieldNamesObject for making column definations
      fieldNamesObject.filter(e => {

        console.log(fieldNamesKeysValues[e]);

        this.columnDefs.push({
          headerName: headerNames[e],
          headerTooltip: headerNames[e],
          tooltipValueGetter: params => headerNames[e] + " : " + params.value,
          field: fieldNamesKeysValues[e],
          filter: "agTextColumnFilter",
          width: 180
        });

      });

      retrieveObject.shift();

      //Removing first json object from retrieveObject
      retrieveObject.shift();



      retrieveObject.filter(e => {

        agGridObject.push(JSON.parse(e));

      });

      console.log(retrieveObject);

      console.log(agGridObject);
      this.gridApi.setGridOption('rowData', agGridObject);
    }

  }

  async publishdata(e) {
    console.log(e)
    let publishresponse: any = [];
    if (confirm("Are you sure you want to Publish") == true) {
      publishresponse = await this.service.updateStatus(e.rowData.screenName, "Yes");
      this.snackBar.open(publishresponse.statusMessage, "OK", { duration: 5000 });
      await this.retrieve();
    }
  }

  async unpublishdata(e) {
    console.log(e)
    let unpublishresponse: any = [];
    if (confirm("Are you sure you want to UnPublish") == true) {
      unpublishresponse = await this.service.updateStatus(e.rowData.screenName, "No");
      this.snackBar.open(unpublishresponse.statusMessage, "OK", { duration: 5000 });
      await this.retrieve();
    }

  }

  async retrieveTransactionData(e) {

    console.log(e);

    if (this.selectedScreenCreator == "TransactionScreenCreator") {

      console.log(e.data.screenId)

      let screenId = e.data.screenId;

      let retrieveObject: any = [];

      //It will return array of 3 json values
      retrieveObject = await this.service.retrieveTransactionService(screenId);

      console.log(retrieveObject);

      let fieldNamesObject: any = [];

      let fieldNamesKeysValues: any = [];

      //Field Names
      fieldNamesKeysValues = JSON.parse(retrieveObject[0]);

      console.log(fieldNamesKeysValues);

      //Getting keys
      fieldNamesObject = Object.keys(fieldNamesKeysValues);

      console.log(fieldNamesObject);

      //Header Names
      let headerNames = JSON.parse(retrieveObject[1]);

      console.log(headerNames);

      //Data
      let agGridObject = JSON.parse(retrieveObject[2]);

      console.log(agGridObject);

      let keyNamesArrangement = [];

      let fieldNamesTemporary = [];

      let headerNamesTemporary = [];

      let dataTemporary = [];

      for (let i = 0; i < fieldNamesObject.length; i++) {

        let j = i + 1;

        //Key Names
        keyNamesArrangement.push("keyName" + j);

        //Field Names
        fieldNamesTemporary.push(fieldNamesKeysValues[keyNamesArrangement[i]]);

        //Header Names
        headerNamesTemporary.push(headerNames[keyNamesArrangement[i]]);

        //Data
        dataTemporary.push(agGridObject[fieldNamesTemporary[i]]);

      }

      console.log(keyNamesArrangement);

      console.log(fieldNamesTemporary);

      console.log(headerNamesTemporary);

      console.log(dataTemporary);

      let width = "80%";

      let dialogRef = this.dialog.open(TransactionDataPopupComponent, {
        maxWidth: '100vw',
        height: '80%',
        width: width,
        data: { displayNames: headerNamesTemporary, displayValues: dataTemporary },
        disableClose: true
      });

      // subcribe the popup after close
      dialogRef.afterClosed().subscribe(result => {

        console.log(result);

      });

    }

  }

  deleteTransactionTable() {

    console.log("deleteMasterTable");

    let width = "55%";

    let dialogRef = this.dialog.open(TransactionScreenCreatorDeleteComponent, {
      maxWidth: '100vw',
      width: width,
      disableClose: true
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(async result => {

      console.log(result);

      await this.retrieve();

    });

  }

  // event on input type file
  screenImageFunction($event): void {
    this.readThisScreenImage($event.target);
  }

  // to encode the selected photo
  readThisScreenImage(inputValue: any): void {

    var file: File = inputValue.files[0];

    var FileS: File = inputValue.files[0];

    console.log(file);

    console.log("file.type");

    console.log(file.type);

    let storingTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/svg+xml', 'image/x-icon'];

    console.log(storingTypes);

    let typeExistInStoringTypes = storingTypes.indexOf(file.type);

    console.log(typeExistInStoringTypes);
    let flag:boolean= this.commonTs.hasMultipleExtensions(file);

    if (!flag&&typeExistInStoringTypes != -1) {

      console.log(file.size / 1000)

      var size = file.size / 1000
      if (size <= 3072) {

        var fileName = FileS.name;

        var imageReference: FileReader = new FileReader();

        imageReference.onloadend = (e) => {

          var image = imageReference.result;
          console.log(imageReference.result)
          var imageBase64Result = imageReference.result.toString().split(',', 2)[1];

          // this is to check the file is empty or not
          if (imageBase64Result == null) {
            this.snackBar.open(this.errormessages.validAttachement, "OK", {
              duration: 5000,
            });
          } else {
            this.screenImage = imageReference.result.toString();
            this.screenImageShow = true
            this.screenCreatorFields.screenImage = imageBase64Result;
            this.screenCreatorFields.screenImageName = fileName;
            this.formValid.controls.screenImageName.setValue(fileName);
          }

        }

        imageReference.readAsDataURL(file);
      } else {
        this.snackBar.open("Selected image " + file.name + ", size should be less than 3MB", "OK", {
          duration: 5000,
        });
        (<HTMLInputElement>document.getElementById('screenImageName'));
      }
    } else {
      this.snackBar.open(file.name + " is a invalid image type ", "OK", {
        duration: 5000,
      });
      (<HTMLInputElement>document.getElementById('screenImageName')).value = null;
    }
  }

  //Delete screenImage.
  deleteScreenImage() {
    this.screenImage = "";
    this.screenImageShow = false;
    this.screenCreatorFields.screenImage = "";
    this.screenCreatorFields.screenImageName = "";
    this.formValid.controls.screenImageName.setValue(null);
    this.formValid.controls.screenImage.setValue(null);
  }

  openScreenImage(image) {

    this.dialog.open(ImageViewInPopupComponent, { width: "55%", height: "555px", data: { "image": this.screenImage } });

  }

  getSanitizer(keyValue) {

    return this.sanitizer.bypassSecurityTrustUrl(keyValue);

  }

  selectScreenCreator(screenCreator) {

    console.log(screenCreator);

    this.selectedScreenCreator = screenCreator;

    this.reset();

  }

  reset() {

    //Creating empty object with doing field values empty
    let empty = { screenName: "", displayName: "", numberOfColumnsInRow: "", screenImageName: "", screenImage: "", multiTenant: true };

    //Assing empty json to screenCreatorFields
    this.screenCreatorFields = empty;

    //Assigning empty array to allFieldsOfMasterTable for clearing allFieldsOfMasterTable array object
    this.allFieldsOfMasterTable = [];

    //Assigning empty array to totalObjectOfMasterTable for clearing totalObjectOfMasterTable array object
    this.totalObjectOfMasterTable = [];
    //Assigning empty array to totalObjectOfMasterTable for clearing totalObjectOfMasterTable array object
    this.totalObjectOfMasterTable = [];

    //Assigning empty array to displayNamesOfMasterTable for clearing displayNamesOfMasterTable array object
    this.displayNamesOfMasterTable = [];

    //Assigning empty array to allFieldsOfTransactionTable for clearing allFieldsOfTransactionTable array object
    this.allFieldsOfTransactionTable = [];

    //Assigning empty array to totalObjectOfTransactionTable for clearing totalObjectOfTransactionTable array object
    this.totalObjectOfTransactionTable = [];

    //Assigning empty array to displayNamesOfTransactionTable for clearing displayNamesOfTransactionTable array object
    this.displayNamesOfTransactionTable = [];

    //Assigning double quotes to masterTableName for clearing masterTableName string
    this.masterTableName = "";

    //Assigning double quotes to masterTableID for clearing masterTableID string
    this.masterTableID = "";

    //Assigning double quotes to transactionTableName for clearing transactionTableName string
    this.transactionTableName = "";

    //Assigning double quotes to transactionTableID for clearing transactionTableID string
    this.transactionTableID = "";

    this.screenNameData = "";

    //Reseting formValid it means like example clearning all validators of formValid
    this.formValid.reset();

    //Calling formValidations
    this.formValidations();

    this.screenImage = "";

    this.screenImageShow = false;

    this.retrieve();

  }

  selectMultiTenant(multiTenant) {

    console.log(typeof multiTenant);

    console.log(multiTenant);

    this.screenCreatorFields.multiTenant = multiTenant;

  }

}
